import React from 'react'
import { MedicalAidPaymentForm } from './Payments'

/**
 * Component for displaying and managing medical aid payment form
 * Note: This component is maintained for backward compatibility
 * and uses the refactored MedicalAidPaymentForm component internally
 * @param {Object} data - Initial data for the medical aid payment
 * @param {Function} handleGetRemittances - Function to refresh remittances
 */
const MedicalAidPaymentFormWrapper = ({ data, handleGetRemittances }) => {
  return <MedicalAidPaymentForm data={data} handleGetRemittances={handleGetRemittances} />
}

export default MedicalAidPaymentFormWrapper
